import React, { createContext, useCallback, useContext, useMemo } from 'react';
import { Calendar } from 'antd';
import { useFilterItems } from '../../services/filterItemsBuilder';
import { Table } from '../../../base/Table';
import { sortByDate } from '../../../../../../helpers/sortFns';
import {
  dateFormats,
  dateTime,
  formatDate,
} from '../../../../shared/packages/dateTime';
import Header from './components/Header';
import { useReviseFilterValue } from '../../services/reviseFilterValue';
import {
  StateProvider,
  useCollection,
  useController,
  useStateSelector,
} from './state';
import { selectDate } from './utils';
import styles from './index.module.scss';

const Context = createContext();

const DateFilter = ({ name }) => {
  const filterItems = useFilterItems(name) || {};
  const { ids } = filterItems ?? {};

  useReviseFilterValue({ name, ids, multiple: false });

  if (!ids || ids.size <= 1) {
    return null;
  }

  return (
    <Context.Provider value={filterItems}>
      <Table.Filter name={name} renderContent={RenderCalendar} />
    </Context.Provider>
  );
};

export default DateFilter;

function RenderCalendar({ value, onChange }) {
  const { data, ids } = useContext(Context);

  const { validRange, sortedData } = useMemo(() => {
    const sorted = sortByDate(data, 'asc', 'value');

    return {
      validRange: [
        dateTime(sorted[0].value),
        dateTime(sorted[sorted.length - 1].value),
      ],
      sortedData: sorted,
    };
  }, [data]);

  return (
    <StateProvider data={sortedData} value={value} onChange={onChange}>
      <CalendarBlock ids={ids} validRange={validRange} />
    </StateProvider>
  );
}

const headerRender = ({ onChange }) => <Header onChange={onChange} />;

function CalendarBlock({ ids, validRange }) {
  const value = useStateSelector(selectDate);

  const { onChange } = useController();

  const collection = useCollection();

  const disabledDate = (current) => {
    const currentStr = formatDate(current, dateFormats.ISO);
    return !ids.has(currentStr);
  };

  return (
    <Calendar
      className={styles.root}
      fullscreen={false}
      onChange={onChange}
      value={value ? value.date : collection.getDefaultDate().date}
      disabledDate={disabledDate}
      validRange={validRange}
      headerRender={headerRender}
    />
  );
}
